import { LicenseManager } from '../../managers/License.manager';
import { Component, OnDestroy } from '@angular/core';
import { WindowBase } from '../../services/window-dialogs/window.base';
import { WindowEvent, WindowActionTypes } from '../../services/window-dialogs/window.event';
import { Subscription } from 'rxjs';
import { MemberDashboard } from '../../../app/models/ss-api/responses/member.dashboard.response';
import { MemberManager } from '../../../app/managers/member.manager';


@Component({
  selector: 'member-details-window',
  styleUrls: ['./member.details.window.css'],
  templateUrl: './member.details.window.html'
})
export class MemberDetailsWindow extends WindowBase<number> implements OnDestroy {


  DashboardData : MemberDashboard = new MemberDashboard();
  private memberManagerSubscription: Subscription;

  constructor() {
    super();
  }


  ngOnDestroy() {

  }

  Init() {

    let manager = new MemberManager(this.Context.Data, true);
    this.memberManagerSubscription = manager.OnChangesSaveResponse.subscribe( response => {
      this.memberManagerSubscription.unsubscribe();  
      console.log("memberManager Subscription response:", response);
      
      this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));

      if (response.Result) {
        response.New.Tags = this.DashboardData.Tags;
        //--- this.DashboardData = data.New;
      }

      window.close();
        
    });
    

  }


}